import { render, staticRenderFns } from "./ManagedMatch.html?vue&type=template&id=51712d83&external"
import script from "./ManagedMatch.vue?vue&type=script&lang=js"
export * from "./ManagedMatch.vue?vue&type=script&lang=js"
import style0 from "./ManagedMatch.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports